
import React, { useState } from 'react';
import ConsumerSummaryCard from '@/components/energy/consumers/ConsumerSummaryCard';
import TopConsumersCard from '@/components/energy/consumers/TopConsumersCard';
import DefaulterConsumersTable from '@/components/energy/consumers/DefaulterConsumersTable';
import ConsumptionTrendsCard from '@/components/energy/consumers/ConsumptionTrendsCard';
import AllConsumersDialog from '@/components/energy/consumers/AllConsumersDialog';
import { topConsumers, defaulterConsumers, allEnergyConsumers } from '@/data/energy-consumers-data';
import CompactLayout from '@/components/layout/CompactLayout';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';

const GasConsumers = () => {
  const [showAllConsumers, setShowAllConsumers] = useState(false);
  const [activeTab, setActiveTab] = useState('summary');
  
  return (
    <CompactLayout>
      <Tabs value={activeTab} onValueChange={setActiveTab} className="h-full flex flex-col">
        <div className="flex-none mb-2">
          <TabsList className="bg-white dark:bg-gray-800 p-1 rounded-lg border dark:border-gray-700">
            <TabsTrigger value="summary">Summary</TabsTrigger>
            <TabsTrigger value="topConsumers">Top Consumers</TabsTrigger>
            <TabsTrigger value="defaulters">Defaulters</TabsTrigger>
            <TabsTrigger value="trends">Consumption Trends</TabsTrigger>
          </TabsList>
        </div>
        
        <div className="flex-1 overflow-hidden">
          <TabsContent value="summary" className="h-full overflow-auto m-0">
            <ConsumerSummaryCard onViewAllClick={() => setShowAllConsumers(true)} />
          </TabsContent>
          
          <TabsContent value="topConsumers" className="h-full overflow-auto m-0">
            <TopConsumersCard consumers={topConsumers} />
          </TabsContent>
          
          <TabsContent value="defaulters" className="h-full overflow-auto m-0">
            <DefaulterConsumersTable defaulters={defaulterConsumers} />
          </TabsContent>
          
          <TabsContent value="trends" className="h-full overflow-auto m-0">
            <ConsumptionTrendsCard />
          </TabsContent>
        </div>
      </Tabs>

      <AllConsumersDialog 
        open={showAllConsumers} 
        onOpenChange={setShowAllConsumers} 
        consumers={allEnergyConsumers} 
      />
    </CompactLayout>
  );
};

export default GasConsumers;
